import React, { useState, useEffect } from 'react';
import { Button, PopOver, Dialog, Radio, Select } from '@tencent/spaui';
import Draggable from 'react-draggable';
import { useSelector, useDispatch } from 'react-redux';
import DeviceDetectComponent from './NetCallDeviceDetectorComponent';
import { OutCallConfigAction } from '../../../actions/OutCallConfigAction';
import { RPCFactory } from '../../../utils/RequestUtil';
const { OverlayTrigger } = PopOver;
const PopoverInternal = PopOver.PopOver;

export const NetCallLoginStateComponent = (props) => {
  const dispatch = useDispatch();
  const showPopoverC = !localStorage.getItem(`Network_check_${window.pageProps.uid}`) || (Date.now() - localStorage.getItem(`Network_check_${window.pageProps.uid}`)) > 24 * 60 * 60 * 1000;
  const [showDeviceDetector, setShowDeviceDetector] = useState(false);
  const [showPopover, setShowPopOver] = useState(false);
  const [showConfig, setShowConfig] = useState(false);
  const outCallConfigState = useSelector((state) => state.outCallConfig);
  const [outCallConfig, setOutCallConfig] = useState(outCallConfigState);

  useEffect(() => {
    if (props.show && showPopoverC) {
      setTimeout(() => {
        setShowPopOver(true);
      }, 1000);
    }
  }, [props.show]);
  const showCallDetector = () => {
    setShowDeviceDetector(true);
  };
  const closeCallDetector = () => {
    setShowDeviceDetector(false);
  };
  const onDisabelTip = () => {
    localStorage.setItem(`Network_check_${window.pageProps.uid}`, Date.now());
    setShowPopOver(false);
  };
  const showConfiger = () => {
    setOutCallConfig(outCallConfigState);
    setShowConfig(true);
  };
  const handleNumAssignModeChange = (numAssignPriorityMode) => {
    setOutCallConfig((config) => ({ ...config, numAssignPriorityMode }));
  };
  const handlePriorityCityCodeChange = (e, numAssignPriorityCity) => {
    setOutCallConfig((config) => ({ ...config, numAssignPriorityCity }));
  };
  const handleConfigCancel = () => {
    setShowConfig(false);
  };
  const handleConfigConfirm = () => {
    const newConfig = {
      callMethod: null, // 默认外呼方式，小程序上可以修改
      numAssignPriorityMode: outCallConfig.numAssignPriorityMode,
      numAssignPriorityCity: outCallConfig.numAssignPriorityCity,
    };
    if (newConfig.numAssignPriorityMode === 'SPECIFIED' && !newConfig.numAssignPriorityCity) {
      alert('请选择指定城市');
      return;
    }
    if (newConfig.numAssignPriorityMode === 'USER_LOCATION') {
      newConfig.numAssignPriorityCity = null;
    }
    const successCallback = () => {
      handleConfigCancel();
      dispatch({
        type: OutCallConfigAction.SET_CONFIG,
        payload: newConfig,
      });
    };
    RPCFactory.call.updateConfig(newConfig)
      .done(successCallback)
      .fail((res, msg) => window.alert(msg));
  };

  return (
    <div>
      <DeviceDetectComponent show={showDeviceDetector} closeDetector={closeCallDetector} roomId={props.roomId} />
      <Dialog
        type='normal'
        className='spaui-dialog-confirm-normal'
        backdrop
        enabledBackdropClose
        cancelButton={false}
        closeButton={false}
        show={props.showLogoutTip}
        onClose={props.handleCloseLogoutTip}
        onSubmit={props.handleCloseLogoutTip}
        title=''
      >
        <div>已登录且正在通话中，通话结束后可在该页面重新登录</div>
      </Dialog>
      <Dialog
        type='normal'
        style={{ width: 600 }}
        className='spaui-dialog-confirm-normal out-call-config'
        show={showConfig}
        onClose={handleConfigCancel}
        onCancel={handleConfigCancel}
        onSubmit={handleConfigConfirm}
        title='设置中间号分配规则'
      >
        <div className="config-block">
          <Radio
            checked={outCallConfig.numAssignPriorityMode === 'USER_LOCATION'}
            onChange={() => handleNumAssignModeChange('USER_LOCATION')}
          >
            优先用户所在地
          </Radio>
          <div className="config-weak-text">系统会优先根据用户所在地分配中间号</div>
        </div>
        <div className="config-block">
          <Radio
            checked={outCallConfig.numAssignPriorityMode === 'SPECIFIED'}
            onChange={() => handleNumAssignModeChange('SPECIFIED')}
          >
            优先指定城市
          </Radio>
          <div className="config-weak-text">系统会优先用指定城市分配中间号</div>
          <div className="config-select">
            <Select
              value={outCallConfig.numAssignPriorityCity || ''}
              onChange={handlePriorityCityCodeChange}
              data={outCallConfigState.cityList}
              valueFieldName="cityName"
              labelFieldName="cityNameCn"
              placeholder="请选择城市"
            />
          </div>
        </div>
      </Dialog>
        {props.show && (
          <Draggable handle=".handle">
            <div className="dragbox">
              <div className="handle" >
                <div className="divid" />
              </div>
              <OverlayTrigger
                show={showPopover}
                placement="bottom"
                overlay={
                  <PopoverInternal className="dark net-check-popover popover-bottom" showDelayTime={1000}>
                    <div className="spaui-popover-body">
                      <p>{'为了保证通话服务，建议使用chrome浏览器，在通话前完成音频及网络检测。'}</p>
                    </div>
                    <div className="spaui-popover-footer">
                      <Button className="pay-notice-confirm" bsSize="small" bsStyle="primary" onClick={onDisabelTip}>
                        我知道了
                      </Button>
                    </div>
                  </PopoverInternal>
                }
              >
                <div className="net-btn" onClick={showCallDetector} style={{ left: 20, top: 12 }}>
                  <div className="net-btn__icon icon-phone-test" />
                  <div className="net-btn__label">通话质检</div>
                </div>
              </OverlayTrigger>
              <div className="net-btn" onClick={showConfiger} style={{ left: 84, top: 12 }}>
                <div className="net-btn__icon icon-city-config" />
                <div className="net-btn__label">通话设置</div>
              </div>
              <div
                className={`logout-net-btn${!props.showLogoutButton ? ' disable' : ''}`}
                style={{ right: 20, top: 20 }}
                onClick={() => props.logoutNetCall()}
              >
                退出
              </div>
            </div>
          </Draggable>
        )}
    </div>
  );
};
